import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import ls from 'localstorage-slim';
import { ButtonTypes } from 'src/app/enums/button-type.enum';
import { Account } from 'src/app/models/account.model';
import { ModalContent } from 'src/app/models/modal-content.model';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { Button } from '../../../models/button.model';

import { SignInvoiceStatus } from 'src/app/enums/sign-invoice-status.enum';
import { EBillsService } from 'src/app/services/e-bills/e-bills.service';
import { generateTimestamp } from 'src/app/shared/utils/date.utils';
ls.config.encrypt = true;
@Component({
  selector: 'lns-challenge-modal',
  templateUrl: './challenge-response-modal.component.html',
  styleUrls: ['./challenge-response-modal.component.scss']
})
export class ChallengeResponseModalComponent implements OnInit {
  @Input() modalContent!: ModalContent;
  @Input() currentPayment!: any;
  @Input() currentAccount!: Account | null;
  @Output() closeModal = new EventEmitter();
  @Output() confirm = new EventEmitter();
  @Input() alreadySigned?: boolean = false;
  loading = false;
  currentPaymentModal: any;
  timestamp = +generateTimestamp();
  encode = '';
  encoded = '';
  retryCount: number = 0;
  maxRetries: number = 30;
  posts: any;
  unsignedOrders: any;
  signInvoiceStatus = SignInvoiceStatus;
  backButton: Button = {
    type: ButtonTypes.TransparentGrayText
  };
  challengeButton: Button = {
    type: ButtonTypes.Success,
    iml: '8',
    submitBtn: true
  };

  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private transactionService: TransactionService,
    private eBillsService: EBillsService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.unsignedOrders = location.href.includes('unsigned-orders');
    if (!this.alreadySigned) {
      this.authorizeSignPaymentOrder();
    }
  }

  onBack(): void {
    this.closeModal.emit();
  }

  async encodePayment() {
    let body: any = {};
    if (this.currentPaymentModal.signTransactionRequestId) {
      body = {
        clientId: ls.get('X-Client-Id'),
        id: this.currentPaymentModal.transactionId,
        debtorAccount: this.currentPaymentModal?.debtorAccount,
        creditorAccount: this.currentPaymentModal?.creditorAccount,
        creditorName: this.currentPaymentModal?.creditorName,
        amount: this.currentPaymentModal?.amount.toFixed(2),
        currency: this.currentPaymentModal?.currency,
        bic: this.currentPaymentModal?.bic,
        signTransactionRequestId:
          this.currentPaymentModal.signTransactionRequestId,
        timestamp: this.currentPaymentModal.timestamp
      };
    } else if (this.currentPaymentModal.signInvoiceRequestId) {
      body = {
        clientId: ls.get('X-Client-Id'),
        invoiceId: this.currentPaymentModal.invoiceId,
        debtorAccount: this.currentPaymentModal?.debtorAccount,
        creditorAccount: this.currentPaymentModal?.creditorAccount,
        creditorName: this.currentPaymentModal?.creditorName,
        paymentAmount: this.currentPaymentModal?.paymentAmount.toFixed(2),
        paymentCurrency: this.currentPaymentModal?.paymentCurrency,
        creditorId: this.currentPaymentModal?.creditorId
          ? this.currentPaymentModal?.creditorId
          : 'null',
        signInvoiceRequestId: this.currentPaymentModal.signInvoiceRequestId,
        timestamp: this.currentPaymentModal.timestamp
      };
    }
    this.encode = Object.values(body).join('|');

    const sha256 = (message: string) => {
      const encoder = new TextEncoder();
      const data = encoder.encode(message);
      return window.crypto.subtle.digest('SHA-256', data);
    };
    const makeCRCTable = function () {
      let c;
      let crcTable = [];
      for (let n = 0; n < 256; n++) {
        c = n;
        for (let k = 0; k < 8; k++) {
          c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        }
        crcTable[n] = c;
      }
      return crcTable;
    };
    const crc32 = function (str: string) {
      var crcTable: any = crcTable || (crcTable = makeCRCTable());
      let crc = 0 ^ -1;
      for (let i = 0; i < str.length; i++) {
        crc = (crc >>> 8) ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xff];
      }
      return (crc ^ -1) >>> 0;
    };
    const bufferToBase64 = (input: ArrayBuffer) => {
      const bytes = new Uint8Array(input);
      return window.btoa(String.fromCharCode(...bytes));
    };
    const shaBuffer = await sha256(this.encode);
    const base64 = bufferToBase64(shaBuffer);
    this.encoded = crc32(base64).toString(16);

    this.confirmPayment(
      this.currentPaymentModal,
      this.encoded,
      this.currentPaymentModal.accountId
    );
  }

  authorizeSignPaymentOrder() {
    const data = this.modalContent.content;
    if (this.currentPayment.invoiceId) {
      this.eBillsService
        .authorizeInvoice(this.currentPayment, data)
        .subscribe(response => {
          this.currentPaymentModal = response.body;
          this.encodePayment();
        });
    } else {
      this.transactionService
        .authorizeSignPaymentOrder(
          this.currentPayment,
          data,
          this.currentAccount?.accountId
        )
        .subscribe(response => {
          this.currentPaymentModal = response.body;
          this.encodePayment();
        });
    }
  }

  confirmPayment(body: any, data: string, accountId: string | undefined) {
    if (!accountId && this.unsignedOrders) {
      accountId = this.currentAccount?.accountId;
    }
    setTimeout(() => {
      if (this.currentPayment.invoiceId) {
        this.eBillsService.signInvoice(body, data).subscribe(response => {
          const status = response.body['signInvoiceStatus']; // Assign the status value
          const multipleSignatureStatusEnum =
            response.body['multipleSignatureStatusEnum']; // Assign the multipleSignatureStatusEnum value
          if (status === SignInvoiceStatus.APPROVED) {
            this.loading = false;
            this.onBack();
          } else if (status === SignInvoiceStatus.WAITING) {
            this.handleWaitingResponse(
              body,
              data,
              accountId,
              status,
              multipleSignatureStatusEnum
            ); // Pass the status to the handleWaitingResponse method
          } else {
            this.loading = false; // Hide the spinner for other statuses
            this.onBack();
          }
        });
      } else {
        this.transactionService
          .signPaymentOrder(body, data, accountId)
          .subscribe(response => {
            const status = response.body['signTransactionStatus']; // Assign the status value
            const multipleSignatureStatusEnum =
              response.body['multipleSignatureStatusEnum'];
            if (status === SignInvoiceStatus.APPROVED) {
              this.loading = false;
              this.onBack();
            } else if (status === SignInvoiceStatus.WAITING) {
              this.handleWaitingResponse(
                body,
                data,
                accountId,
                status,
                multipleSignatureStatusEnum
              ); // Pass the values to the handleWaitingResponse method
            } else {
              this.loading = false; // Hide the spinner for other statuses
              this.onBack();
            }
          });
      }
    }, 500);
  }

  handleWaitingResponse(
    body: any,
    data: string,
    accountId: string | undefined,
    status: string,
    multipleSignatureStatusEnum: string
  ) {
    this.maxRetries = Math.floor(this.currentPayment.poolingTimeout! / 4);
    const retry = () => {
      if (this.retryCount >= this.maxRetries) {
        this.loading = false;
        this.retryCount = 0;
        return;
      }
      this.retryCount++;

      if (body.invoiceId) {
        this.eBillsService
          .signInvoice(body, data)
          .subscribe(waitingResponse => {
            status = waitingResponse.body['signInvoiceStatus']; // Update the status value
            multipleSignatureStatusEnum =
              waitingResponse.body['multipleSignatureStatusEnum']; // Update the multipleSignatureStatusEnum value

            if (status === SignInvoiceStatus.APPROVED) {
              this.unsignedOrders
                ? this.successResponseUnsignedOrder(
                    waitingResponse,
                    multipleSignatureStatusEnum
                  )
                : this.successResponseEbills(
                    waitingResponse,
                    multipleSignatureStatusEnum
                  );
              this.retryCount = 0;
              this.loading = false;
            } else if (status === SignInvoiceStatus.WAITING) {
              setTimeout(retry, 4000); // Retry after 4 seconds if status is still 'WAITING'
            }
          });
      } else {
        this.transactionService
          .signPaymentOrder(body, data, accountId)
          .subscribe(waitingResponse => {
            status = waitingResponse.body['signTransactionStatus']; // Update the status value
            multipleSignatureStatusEnum =
              waitingResponse.body['multipleSignatureStatusEnum']; // Update the multipleSignatureStatusEnum value

            if (status === SignInvoiceStatus.APPROVED) {
              this.unsignedOrders
                ? this.successResponseUnsignedOrder(
                    waitingResponse,
                    multipleSignatureStatusEnum
                  )
                : this.successResponsePayment(
                    waitingResponse,
                    multipleSignatureStatusEnum
                  );
              this.retryCount = 0;
              this.loading = false;
            } else if (status === SignInvoiceStatus.WAITING) {
              setTimeout(retry, 4000); // Retry after 4 seconds if status is still 'WAITING'
            }
          });
      }
    };
    retry(); // Start the retry process
  }

  successResponsePayment(
    waitingResponse: any,
    multipleSignatureStatusEnum: string // Handle success response when is standard payment
  ) {
    if (multipleSignatureStatusEnum == 'PARTIALLY_SIGNED') {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            sidebar: ['success-payment-partially-signed-no-valuation']
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'FULLY_SIGNED') {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            sidebar: ['success-payment-fully-signed-no-valuation']
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'FULLY_SIGNED_VALUATION') {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            sidebar: [
              'success-payment-fully-signed-valuation',
              waitingResponse.body!['valuationDate']
            ]
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'NONE_VALUATION') {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            sidebar: [
              'success-payment-valuation',
              waitingResponse.body!['valuationDate']
            ]
          }
        }
      ]);
    } else {
      this.router.navigate([
        '/payments',
        {
          outlets: { sidebar: ['success-payment-no-valuation'] }
        }
      ]);
    }
  }

  successResponseEbills(
    waitingResponse: any,
    multipleSignatureStatusEnum: string // Handle success response when is standard payment
  ) {
    if (multipleSignatureStatusEnum == 'PARTIALLY_SIGNED') {
      this.router.navigate([
        '/e-bills',
        {
          details: ['e-bills'],
          outlets: {
            sidebar: ['success-payment-partially-signed-no-valuation']
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'FULLY_SIGNED') {
      this.router.navigate([
        '/e-bills',
        {
          details: ['e-bills'],
          outlets: {
            sidebar: ['success-payment-fully-signed-no-valuation']
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'FULLY_SIGNED_VALUATION') {
      this.router.navigate([
        '/e-bills',
        {
          details: ['e-bills'],
          outlets: {
            sidebar: [
              'success-payment-fully-signed-valuation',
              waitingResponse.body!['valuationDate']
            ]
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'NONE_VALUATION') {
      this.router.navigate([
        '/e-bills',
        {
          details: ['e-bills'],
          outlets: {
            sidebar: [
              'success-payment-valuation',
              waitingResponse.body!['valuationDate']
            ]
          }
        }
      ]);
    } else {
      this.router.navigate([
        '/e-bills',
        {
          details: ['e-bills'],
          outlets: { sidebar: ['success-payment-no-valuation'] }
        }
      ]);
    }
  }

  successResponseUnsignedOrder(
    waitingResponse: any,
    multipleSignatureStatusEnum: string // Handle success response when is unsigned orders
  ) {
    if (multipleSignatureStatusEnum == 'PARTIALLY_SIGNED') {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            details: ['unsigned-orders'],
            sidebar: ['success-payment-partially-signed-no-valuation']
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'FULLY_SIGNED') {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            details: ['unsigned-orders'],
            sidebar: ['success-payment-fully-signed-no-valuation']
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'FULLY_SIGNED_VALUATION') {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            details: ['unsigned-orders'],
            sidebar: [
              'success-payment-fully-signed-valuation',
              waitingResponse.body!['valuationDate']
            ]
          }
        }
      ]);
    } else if (multipleSignatureStatusEnum == 'NONE_VALUATION') {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            details: ['unsigned-orders'],
            sidebar: [
              'success-payment-valuation',
              waitingResponse.body!['valuationDate']
            ]
          }
        }
      ]);
    } else {
      this.router.navigate([
        '/payments',
        {
          outlets: {
            details: ['unsigned-orders'],
            sidebar: ['success-payment-no-valuation']
          }
        }
      ]);
    }
  }
}
